export function equals(comparable?: string, message = 'Os valores são diferentes') {
  return (value: string) => value === comparable || message
}
